import React from 'react'

const Star = props => (
  <svg width={props.size} height={props.size} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M17.159 14.226a1 1 0 0 0-.277.886l1.1 6.053-5.369-2.81a1.001 1.001 0 0 0-.912-.006l-5.69 2.858 1.106-6.095a1.002 1.002 0 0 0-.276-.886L3.03 10.414l5.5-1.1c.301-.06.561-.258.698-.533L12 3.236l2.772 5.545a1 1 0 0 0 .7.533l5.499 1.1-3.812 3.812zm6.798-4.716a1 1 0 0 0-.761-.691l-6.854-1.37L12.894.553a.998.998 0 0 0-1.789 0L7.657 7.449.805 8.819a.995.995 0 0 0-.761.69.995.995 0 0 0 .25.998l4.761 4.763-1.373 7.55a1.002 1.002 0 0 0 1.433 1.074l7.025-3.528 6.729 3.52a1 1 0 0 0 1.447-1.065l-1.373-7.551 4.764-4.763a.997.997 0 0 0 .25-.997z"
    />
  </svg>
)

export default Star
